const defaultMessage = 'Something went wrong. Please try again.';

const sensitivePatterns = [
  /row-level security/i,
  /duplicate key/i,
  /foreign key/i,
  /check constraint/i,
  /violates/i,
  /permission denied/i,
  /postgrest/i,
  /pgrst/i,
  /sqlstate/i,
  /schema cache/i,
  /relation .* does not exist/i,
  /column .* does not exist/i,
  /https?:\/\//i,
];

const knownMessages = [
  {
    test: /invalid login credentials/i,
    message: 'We could not sign you in with those details.',
  },
  {
    test: /email not confirmed/i,
    message: 'Confirm your email before signing in.',
  },
  {
    test: /EMAIL_ALREADY_EXISTS|user already registered|already exists/i,
    message: 'An account with that email already exists. Try signing in instead.',
  },
  {
    test: /profiles_username_unique|username.*taken/i,
    message: 'That username is not available. Choose a different username and try again.',
  },
  {
    test: /message cannot be empty/i,
    message: 'Add a message before sending.',
  },
  {
    test: /choose a file/i,
    message: 'Choose a file before uploading.',
  },
  {
    test: /mime|file type|unsupported|not allowed/i,
    message: 'That file type is not supported. Try a PDF, image, document, spreadsheet, CSV, or text file.',
  },
  {
    test: /connect stripe/i,
    message: 'Connect Stripe before continuing.',
  },
  {
    test: /sign in/i,
    message: 'Sign in before continuing.',
  },
  {
    test: /not available for orders|seller is not ready/i,
    message: 'This listing is not ready for orders yet.',
  },
  {
    test: /only completed buyer orders can be reviewed/i,
    message: 'Reviews can be submitted after a buyer order is completed.',
  },
  {
    test: /only the buyer or seller/i,
    message: 'You do not have access to perform that action.',
  },
];

export function getUserFacingError(error, fallback = defaultMessage) {
  const rawMessage = String(error?.message || error || '').trim();

  if (!rawMessage) {
    return fallback;
  }

  const known = knownMessages.find((entry) => entry.test.test(rawMessage));
  if (known) {
    return known.message;
  }

  if (sensitivePatterns.some((pattern) => pattern.test(rawMessage))) {
    return fallback;
  }

  if (rawMessage.length > 140) {
    return fallback;
  }

  return rawMessage;
}
